<template>
  <div
    ref="dragBall"
    class="drag-ball"
    :class="{transition:transition}"
    :style="{width: width+'px', height: height+'px', right: right+'px', bottom: bottom+'px'}"
    @touchstart.stop.prevent="touchstart"
    @touchmove.stop.prevent="touchmove"
    @touchend.stop.prevent="touchend">
    <slot>
      <div class="ball">悬浮球</div>
    </slot>
  </div>
</template>
<script>
export default {
  name: 'drag-ball',
  props: {
    width: {
      type: Number,
      default: 70
    },
    height: {
      type: Number,
      default: 70
    },
    right: {
      type: Number,
      default: 20
    },
    bottom: {
      type: Number,
      default: 100
    },
    // 距离底部多高
    limtBot: {
      type: Number,
      default: 60,
    },
  },
  data() {
    return {
      canDrag: false,
      // 偏移
      transition:false,
      inset: {
        left: 0,
        top: 0
      },
      // 移动
      move: {},
      // 位置
      position: {
        left: 0,
        top: 0
      },
      // 初始位置
      positionOld: {},
      startTime: null,
      endTime: null
    };
  },
  methods: {
    touchstart(e) {
      this.transition = false
      if (!this.canDrag) {
        this.startTime = e.timeStamp;
        this.positionOld = this.getPosition(this.dragBall);
        this.position = { ...this.positionOld };
        this.inset = {
          left: e.targetTouches[0].clientX - this.positionOld.left,
          top: e.targetTouches[0].clientY - this.positionOld.top
        };
        this.canDrag = true;
      }
    },
    touchmove(e) {
      if (this.canDrag) {
        let left = e.targetTouches[0].clientX - this.inset.left;
        let top = e.targetTouches[0].clientY - this.inset.top;
        if (left < 0) {
          left = 0;
        } else if (left > (window.innerWidth - this.dragBall.offsetWidth)) {
          left = window.innerWidth - this.dragBall.offsetWidth;
        }
        if (top < 0) {
          top = 0;
        } else if (top > (window.innerHeight - this.dragBall.offsetHeight - this.limtBot)) {
          top = window.innerHeight - this.dragBall.offsetHeight - this.limtBot;
        }
        this.dragBall.style.left = left + 'px';
        this.dragBall.style.top = top + 'px';
        this.move = {
          x: left - this.positionOld.left,
          y: top - this.positionOld.top
        };
        this.position = { left, top };
      }
    },
    touchend(e) {
      this.transition = true
      if (this.canDrag) {
        this.endTime = e.timeStamp;
        if (this.endTime - this.startTime > 400 || Math.abs(this.move.x) > 2 || Math.abs(this.move.y) > 2) {
          // 非单击事件
          if ((this.position.left + this.dragBall.offsetWidth / 2) > window.innerWidth / 2) {
            this.dragBall.style.left = window.innerWidth - this.dragBall.offsetWidth - this.right + 'px';
          } else {
            this.dragBall.style.left = this.right + 'px';
          }
        } else {
          this.$emit('click');
        }
        this.inset = {};
        this.move = {};
        this.position = {};
        this.canDrag = false;
      }
    },
    // 获取dom的绝对位置
    getPosition(source) {
      let left = source.offsetLeft; //获取元素相对于其父元素的left值var left
      let top = source.offsetTop;
      let current = source.offsetParent; // 取得元素的offsetParent // 一直循环直到根元素
      while (current != null) {
        left += current.offsetLeft;
        top += current.offsetTop;
        current = current.offsetParent;
      }
      return {
        left: left,
        top: top
      };
    }
  },
  computed: {
    dragBall() {
      return this.$refs.dragBall;
    }
  }
};
</script>
<style scoped lang="scss">
.drag-ball {
  position: fixed;
  z-index: 10003;
  right: 0;
  bottom: 100px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;

  &.transition{
     transition: all .25s;
   }
}
.drag-ball .ball {
  background-color: #fff;
  display: flex;
  padding-left: 4px;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 50px;
  color: #666666;
  font-size: 12px;
  z-index: 100;
  border-radius: 50%;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
}
</style>
